module.exports = __webpack_public_path__ + "img/logo-mew-dark.5d962d4e.png";